// Function to set up the marquee for a specific element
function setupMarquee(elementId) {
  const marqueeList = document.getElementById(elementId);
  if (!marqueeList) {
    return; // Exit the function if the element with the given ID doesn't exist
  }

  const marqueeItems = marqueeList.querySelectorAll('.revolving-text-list li');
  const marqueeItemWidth = marqueeItems[0].offsetWidth + (parseFloat(getComputedStyle(marqueeItems[0]).paddingLeft) + parseFloat(getComputedStyle(marqueeItems[0]).paddingRight));
  const totalWidth = marqueeItemWidth * marqueeItems.length;

  // Set the animation duration based on the total width and animation speed (e.g., 100px per second)
  const speed = 40;
  const animationDuration = (totalWidth / speed) + 's';

  // Set the marquee container width
  const marqueeContainer = document.querySelector('.revolving-text-container');
  marqueeContainer.style.width = totalWidth + 'px';

  // Set the animation duration and iteration count
  marqueeList.style.animationDuration = animationDuration;

  // Clone the list items and append them to the container to create a continuous loop
  marqueeItems.forEach(item => {
    marqueeList.appendChild(item.cloneNode(true));
  });
}

// Call the setupMarquee function for each element you want to create a marquee for
document.addEventListener('DOMContentLoaded', function () {
  setupMarquee('revolving-text'); 
  setupMarquee('revolving-text-follow'); 
  setupMarquee('revolving-text');
});
